import FeatureCard from "../FeatureCard";
import SkeletonCard from "./SkeletonCard";
import { useContainerWidth } from "./hooks/useContainerWidth";

const IDEAL_WIDTH = 230;
const MIN_WIDTH = 210;
const GAP = 24;

const CardGrid = ({
  data = [],
  loading = false,
  loadingMode = "replace",
  loadingCount = 3,
  showText = false,
  neutralArrow = false,
  disableEntryAnimation = false,
}) => {
  const { ref, width } = useContainerWidth();

  const shouldAppendLoading = loading && loadingMode === "append";
  const itemsCount = shouldAppendLoading
    ? data.length + loadingCount
    : loading
      ? loadingCount
      : data.length;

  const neededWidth =
    itemsCount * IDEAL_WIDTH + (itemsCount - 1) * GAP;

  const canUseFixed = width >= neededWidth;

  const gridTemplateColumns = canUseFixed
    ? `repeat(${itemsCount}, ${IDEAL_WIDTH}px)`
    : `repeat(auto-fit, minmax(${MIN_WIDTH}px, 1fr))`;

  const getItemKey = (item, index) =>
    item?.key || item?.id || item?.title || `card-${index}`;

  return (
    <div
      ref={ref}
      style={{
        marginTop: "16px",
        display: "grid",
        gap: `${GAP}px`,
        gridTemplateColumns,
        gridAutoRows: "1fr",
        alignItems: "stretch",
      }}
    >
      {loading
        ? loadingMode === "replace"
          ? Array.from({ length: loadingCount }).map((_, index) => (
              <SkeletonCard key={`skeleton-${index}`} />
            ))
          : (
            <>
              {data.map((item, index) => (
                <FeatureCard
                  key={getItemKey(item, index)}
                  {...item}
                  showText={showText}
                  neutralArrow={neutralArrow}
                  disableEntryAnimation={disableEntryAnimation}
                />
              ))}
              {Array.from({ length: loadingCount }).map((_, index) => (
                <SkeletonCard key={`skeleton-${index}`} />
              ))}
            </>
          )
        : data.map((item, index) => (
            <FeatureCard
              key={getItemKey(item, index)}
              {...item}
              showText={showText}
              neutralArrow={neutralArrow}
              disableEntryAnimation={disableEntryAnimation}
            />
          ))}
    </div>
  );
};

export default CardGrid;
